import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M2.5 11a8.5 8.5 0 113.958 7.186 1 1 0 00-.821-.113l-2.88.86 1.085-2.538a1 1 0 00-.07-.92A8.456 8.456 0 012.5 11zM11 .5C5.201.5.5 5.201.5 11c0 1.838.473 3.568 1.305 5.073L.08 20.107a1 1 0 001.206 1.351l4.5-1.342A10.455 10.455 0 0011 21.5c5.799 0 10.5-4.7 10.5-10.5C21.5 5.201 16.799.5 11 .5zm2.293 12.682l-1.315.926A9.338 9.338 0 0110 12.585a10.201 10.201 0 01-1.624-2.114l.835-.709a1 1 0 00.236-1.232l-1.064-2a1 1 0 00-1.54-.283l-.316.275c-.759.662-1.208 1.75-.836 2.852A12.05 12.05 0 008.586 14c1.813 1.813 3.655 2.527 4.733 2.805.868.223 1.689-.076 2.268-.548l.591-.482a1 1 0 00-.12-1.634l-1.678-1a1 1 0 00-1.088.041h.001z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
